import React from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "../../context/WishlistContext";

export const HeartButton = ({ product, className = "" }) => {
  const { has, toggle } = useWishlist();
  const active = has(product.id);
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(product);
    toast.success(active ? "Retiré de vos favoris" : "Ajouté à vos favoris");
  };
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={active ? "Retirer des favoris" : "Ajouter aux favoris"}
      data-testid={`wishlist-toggle-${product.id}`}
      className={`flex h-9 w-9 items-center justify-center rounded-full bg-white/90 shadow-sm backdrop-blur transition-transform hover:scale-110 active:scale-95 ${className}`}
    >
      <Heart className={`h-4 w-4 ${active ? "fill-[#D76E4D] text-[#D76E4D]" : "text-[#2C1A14]"}`} />
    </button>
  );
};
